module.exports = __webpack_public_path__ + "media/images/lb/478-0bdf5bbe753396fc7945ff97a7592688.svg";